module.exports = __webpack_public_path__ + "img/8_61.2d6fbd68.png";